import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TableRow, TableCell } from '@mui/material';
import { confirmDialog } from '../Reusable/ConfirmDialog';
import ModalForUpdateTravelOrder from './ModalForUpdateTravelOrder';
import { download } from '../../actions/travelOrder';


const TravelOrderRow = ({
  travelOrder,
  updateTravelOrder,
  deleteTravelOrder,
  dispatch,
  travelOrderReducer,
  clearValidationErrors,
  municipalities
}) => {
  const [show, setShow] = useState(false);

   const onDownloadClick = (id) => {
    dispatch(download(id));
  };

  const onDeleteClick = (id) => {
    const action = () => {
      dispatch(deleteTravelOrder(id));
    };
    confirmDialog('obrišete putni nalog ', action, ', obriši!');
  };

  const showModalUpdate = () => {
    setShow(true);
  };

  const handlePreviewClose = () => {
    setShow(false);
    clearValidationErrors();
  };

  const handleEdit = (travelOrder) => {
    dispatch(updateTravelOrder(travelOrder, handlePreviewClose));
  };

  let row = (
    <>
      <TableRow>
        <TableCell>{travelOrder.startDateTime}</TableCell>
        <TableCell>{travelOrder.returnDateTime}</TableCell>
        <TableCell>{municipalities.find(m => m.id === travelOrder.startPointId)?.name}</TableCell>
        <TableCell>{municipalities.find(m => m.id === travelOrder.returnPointId)?.name}</TableCell>
        <TableCell>{travelOrder.refueling}</TableCell>

        <TableCell className="text-center" id="centerRow">
          <Link to="#" onClick={() => showModalUpdate()}>
            <i className="fas fa-edit fa-2x i" />
          </Link>
        </TableCell>
        <TableCell
          className={`text-center ${travelOrder.id === 2 && 'disable-events'}`}
        >
          <Link to="#" id="deleteTravelOrder" onClick={() => onDeleteClick(travelOrder.id)}>
            <i
              className={`fas fa-trash-alt fa-2x ${travelOrder.id === 2 && 'disable-color'
                }`}
            />
          </Link>
        </TableCell>
        <TableCell
        >
          <Link to="#" id="downloadTravelOrder" onClick={() => onDownloadClick(travelOrder.id)}>
            <i className="fas fa-download fa-2x" />
          </Link>
        </TableCell>
      </TableRow>
    </>
  );

  return (
    <>
      {row}

      {show && (
        <ModalForUpdateTravelOrder
          show={show}
          travelOrder={travelOrder}
          updateTravelOrder={handleEdit}
          handleClose={handlePreviewClose}
          travelOrderReducer={travelOrderReducer}
          municipalities={municipalities}
        />
      )}
    </>
  );
};

export default TravelOrderRow;
